export class CommercialPermitNumberModel {
    public commercialVehiclePermitNumberId: number;
    public commercialVehiclePermitTypeId: number;
    public customerNumberId: number;
    public issueDate: Date;
    public expirationDate: Date;
    public supplementTypeIds: number[];
}
